import { useTranslation } from 'next-i18next'

import { isEmptyOrNull } from '@/utils'

const useFilterSlug = (filterSlug: string) => {
  const { t } = useTranslation()

  const hasFilter = !isEmptyOrNull(filterSlug)
  const filterTitle = t(`seo:filter_name_${filterSlug}`, filterSlug)
  const filterName = filterTitle.toLowerCase()

  return { hasFilter, filterTitle, filterName }
}

export default useFilterSlug
